import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import {
  OffboardingRequirementsDialogComponent
} from '../offboarding-requirements-dialog/offboarding-requirements-dialog.component';
import { OffboardingService } from '../offboarding.service';
import { OrderCreateService } from '../../../order/order-create/order-create.service';
import { RelayIdService } from '../../../shared/relay-id.service';

@Component({
  selector: 'app-offboarding-requirements-list',
  templateUrl: './offboarding-requirements-list.component.html',
  styleUrls: ['./offboarding-requirements-list.component.scss']
})
export class OffboardingRequirementsListComponent implements OnInit {
  offboardingRolesSet = {};
  roles = [];
  isLoading = true;
  chosenRole = undefined;
  company = [];
  preChosenId;

  @Input() set order(value) {
    if (value && !this.company.length) {
      if (value.offboardingRoles.edges.length) {
        const preselectedRole = value.offboardingRoles.edges[0];
        this.chosenRole = {
          id: preselectedRole.node.id,
          companyId: preselectedRole.node.company.id,
          name: preselectedRole.node.name,
          updatedAt: preselectedRole.node.updatedAt,
          createdAt: preselectedRole.node.createdAt,
          actions: [...preselectedRole.node.actions]
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map(v => v.description),
          chosen: true
        };
        this.preChosenId = preselectedRole.node.id;
      }
      this.company = [value?.company?.id];
      this.getOffboardingRoles();
    }
  }
  @Input() set setCompany(value) {
    if (value && typeof value !== 'string' && this.company[0] !== value.id) {
      const id = this.relayIdService.parseIdAsCompanyType(this.orderCreateService.selectedCompany.value?.id);
      this.company = [id];
      this.getOffboardingRoles();
    }
  }
  @Output() inputRolesIdsChange = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private offboardingService: OffboardingService,
    private orderCreateService: OrderCreateService,
    private relayIdService: RelayIdService
  ) { }

  ngOnInit(): void {
  }

  getOffboardingRoles() {
    this.offboardingService.getAllRoles()
      .subscribe(v => {
        this.roles = [];
        this.offboardingRolesSet = {};
        v.data.offboardingRoles.edges.map(value => {
          if (this.offboardingRolesSet[value.node.company.id]?.length) {
            const role = {
              id: value.node.id,
              companyId: value.node.company.id,
              name: value.node.name,
              updatedAt: value.node.updatedAt,
              createdAt: value.node.createdAt,
              actions: [...value.node.actions]
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .map(it => it.description),
              chosen: false
            };

            if (role.id === this.preChosenId) {
              this.offboardingRolesSet[value.node.company.id].push(this.chosenRole);
            } else {
              this.offboardingRolesSet[value.node.company.id].push(role);
            }
          } else {
            const role = {
              id: value.node.id,
              companyId: value.node.company.id,
              name: value.node.name,
              updatedAt: value.node.updatedAt,
              createdAt: value.node.createdAt,
              actions: [...value.node.actions]
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .map(it => it.description),
              chosen: false
            };

            if (role.id === this.preChosenId) {
              this.offboardingRolesSet[value.node.company.id] = [this.chosenRole];
            } else {
              this.offboardingRolesSet[value.node.company.id] = [role];
            }
          }
        });
      });
  }

  getPreparedOffboardingRoles() {
    const raw = this.company.map(v => this.offboardingRolesSet[v]).filter(v => !!v);
    if (raw.length) {
      let result = [];
      raw.map(v => {
        result = result.concat(v);
      });
      return result;
    } else {
      return [];
    }
  }

  manageOffboardingRequests(res) {
    if (res) {
      if (res?.data && res?.data.length) {
        res.data.map(value => {
          const input = {
            companyId: '',
            name: value.name,
            actions: value.actions
          };
          if (value?.needCreate) {
            value.companyId.map(id => {
              input.companyId = id;
              this.offboardingService.createRole(input).subscribe(role => {
                const newRole = {
                  id: role.data.createOffboardingRole.offboardingRole.id,
                  companyId: role.data.createOffboardingRole.offboardingRole.company.id,
                  name: role.data.createOffboardingRole.offboardingRole.name,
                  updatedAt: role.data.createOffboardingRole.offboardingRole.updatedAt,
                  createdAt: role.data.createOffboardingRole.offboardingRole.createdAt,
                  actions: [...role.data.createOffboardingRole.offboardingRole.actions]
                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                    .map(it => it.description),
                  chosen: value.chosen
                };
                if (this.offboardingRolesSet[id]) {
                  this.offboardingRolesSet[id].push(newRole);
                } else {
                  this.offboardingRolesSet[id] = [newRole];
                }
                if (value.chosen) {
                  this.chosenRole = newRole;
                }
                this.inputRolesIdsChange.emit(this.getPreparedOffboardingRoles().filter(it => it?.chosen).map(it => it?.id));
              });
            });
          } else if (value?.needUpdate) {
            input.companyId = value.companyId;
            this.offboardingService.updateRole(value.id, input).subscribe(result => {
              this.offboardingRolesSet[value.companyId] = this.offboardingRolesSet[value.companyId].map(role => {
                if (role.id === result.data.updateOffboardingRole.offboardingRole.id) {
                  return {
                    id: result.data.updateOffboardingRole.offboardingRole.id,
                    companyId: result.data.updateOffboardingRole.offboardingRole.company.id,
                    name: result.data.updateOffboardingRole.offboardingRole.name,
                    updatedAt: result.data.updateOffboardingRole.offboardingRole.updatedAt,
                    createdAt: result.data.updateOffboardingRole.offboardingRole.createdAt,
                    actions: [...result.data.updateOffboardingRole.offboardingRole.actions]
                      .sort((a, b) => (a.order || 0) - (b.order || 0))
                      .map(it => it.description),
                    chosen: value.chosen
                  };
                } else {
                  return role;
                }
              });
              this.inputRolesIdsChange.emit(this.getPreparedOffboardingRoles().filter(it => it?.chosen).map(it => it?.id));
            });
          }
        });
      }

      if (res.needsToBeDeleted && res.needsToBeDeleted.length) {
        res.needsToBeDeleted.map((item) => {
          this.offboardingService.deleteRole(item.id).subscribe(role => {
            if (role.data.deleteOffboardingRole.ok) {
              this.offboardingRolesSet[item.companyId] =
                this.offboardingRolesSet[item.companyId].filter(v => v.id !== item.id);
            }
            this.inputRolesIdsChange.emit(this.getPreparedOffboardingRoles().filter(it => it?.chosen).map(it => it?.id));
          });
        });
      }
    }
  }

  openRequirementsChooseEditDialog(): void {
    this.dialog.open(OffboardingRequirementsDialogComponent, {
      data: {
        isOrderView: true,
        roles: this.getPreparedOffboardingRoles(),
        companies: this.company,
      },
      width: '750px',
      panelClass: 'offboarding-requirements'
    }).afterClosed().subscribe(v => {
      if (v) {
        this.manageOffboardingRequests(v);
        if (v?.chosen) {
          if (v.needsToBeDeleted.length && v.needsToBeDeleted.some(deleted => deleted?.id === v.chosen.id)) {
            this.chosenRole = undefined;
            this.inputRolesIdsChange.emit([]);
          } else {
            if (this.offboardingRolesSet[v.chosen.companyId]) {
              this.offboardingRolesSet[v.chosen.companyId] = this.offboardingRolesSet[v.chosen.companyId].map(role => {
                if (role.id === v.chosen.id) {
                  return v.chosen;
                } else {
                  return {
                    ...role,
                    chosen: false
                  };
                }
              });
            } else {
              this.offboardingRolesSet[v.chosen.companyId] = [v.chosen];
            }
            this.chosenRole = v?.chosen;
            this.inputRolesIdsChange.emit([this.chosenRole.id]);
          }
        } else {
          this.chosenRole = undefined;
          this.inputRolesIdsChange.emit([]);
        }
      }
    });
  }

}
